/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import produce from 'immer';
import { sanitizeCnpj, filledFieldNames, mergeFidelizeAutofill } from 'services/conlicitaseg';
import { ProfileTypes } from 'store/modules/profile_store/types';
import { ConlicitasegTypes, ConlicitasegState } from './types';

const INITIAL_STATE_REQUEST = {
  get_quotes: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_quote_by_company: {
    junto: {
      loading: false,
      loaded: false,
      error: false,
    },
    pottencial: {
      loading: false,
      loaded: false,
      error: false,
    },
    sombrero: {
      loading: false,
      loaded: false,
      error: false,
    },
    avla: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
  submit_quote_with_payment: {
    loading: false,
    loaded: false,
    error: false,
  },
  search_company_data: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_proposal: {
    loading: false,
    loaded: false,
    error: false,
  },
  get_insured: {
    loading: false,
    loaded: false,
    error: false,
  },
  get_quote_by_id: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_process: {
    loading: false,
    loaded: false,
    error: false,
  },
  update_quote_by_company: {
    junto: {
      loading: false,
      loaded: false,
      error: false,
    },
    pottencial: {
      loading: false,
      loaded: false,
      error: false,
    },
    sombrero: {
      loading: false,
      loaded: false,
      error: false,
    },
    avla: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
  get_bidding_guarantee_data: {
    loading: false,
    loaded: false,
    error: false,
  },
  get_fidelize_bidding_guarantee: {
    loading: false,
    loaded: false,
    error: false,
  },
  get_company_name: {
    loading: false,
    loaded: false,
    error: false,
  },
  get_client_policyholders: {
    loading: false,
    loaded: false,
    error: false,
  },
  create_client_policyholder: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const INITIAL_STATE: ConlicitasegState = {
  processes: [],
  last_quotes: [],
  formProcess: {
    bidding_id: 0,
    policyholder_cnpj: '',
    policyholder_company_name: '',
    type_warranty_id: '',
    bidding_modality: '',
    bidding_edict: '',
    bidding_contract_number: '',
    bidding_process_number: '',
    contract_days: 0,
    contract_start_date: '',
    contract_end_date: '',
    contract_value: 0,
    contract_percentage: 0,
    contract_insured_amount: 0,
    quote_date: '',
    insured_cnpj: '',
    insured_name: '',
    insured_address: '',
    insured_zip_code: '',
    insured_number: '',
    insured_district: '',
    insured_city: '',
    insured_state: '',
    policyholder_register_junto: true,
    policyholder_register_sombrero: true,
    policyholder_register_avla: true,
    contract_additional_value: 0,
    policyholder_cnpj_matriz: '',
  },
  policyholder_register_junto: true,
  policyholder_register_pottencial: true,
  policyholder_register_sombrero: true,
  policyholder_register_avla: true,
  resume_process: false,
  second_quote_try: false,
  selected_quote: {},
  company_data_junto: {
    status: '',
    message: '',
    name: '',
    insurance_company_id: '',
  },
  company_data_pottencial: {
    status: '',
    message: '',
    name: '',
    insurance_company_id: '',
  },
  company_data_sombrero: {
    status: '',
    message: '',
    name: '',
    insurance_company_id: '',
  },
  company_data_avla: {
    status: '',
    message: '',
    name: '',
    insurance_company_id: '',
  },
  insured_data: {
    insured_zip_code: '',
    insured_address: '',
    insured_number: '',
    insured_district: '',
    insured_city: '',
    insured_state: '',
    insured_name: '',
    insured_public_legal_nature: false,
  },
  current_process_id: null,
  quote_flow: null,
  guarantee_type: null,
  origin_channel: 'dashboard',
  fidelize_login_redirect_pending: false,
  fidelize_email_link_applied: false,
  contract_uploaded: true,
  get_company_name: {
    name: '',
    tipo_empresa: '',
    policyholder_cnpj_matriz: '',
    policyholder_public_legal_nature: false,
  },
  has_orgao_cnpj: true,
  autofilled_fields: [],
  client_policyholders: [],
  request: { ...INITIAL_STATE_REQUEST },
};

const reducer: Reducer<ConlicitasegState> = (
  state = INITIAL_STATE,
  {
    type,
    result,
    payload,
    quoteData,
    insurance_process_id,
    type_warranty,
    cnpj,
    fidelize_fallback,
    mark_autofill,
  },
) => {
  if (type === ConlicitasegTypes.CLEAR_FORM_QUOTE) {
    return {
      ...INITIAL_STATE,
      processes: state.processes,
      client_policyholders: state.client_policyholders,
      fidelize_login_redirect_pending: state.fidelize_login_redirect_pending,
      fidelize_email_link_applied: state.fidelize_email_link_applied,
      request: {
        ...INITIAL_STATE_REQUEST,
        get_quotes: state.request.get_quotes,
        get_client_policyholders: state.request.get_client_policyholders,
      },
    };
  }

  return produce(state, (draft) => {
    switch (type) {
      case ConlicitasegTypes.GET_QUOTES_REQUEST: {
        draft.request.get_quotes = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_QUOTES_SUCCESS: {
        draft.request.get_quotes = {
          loading: false,
          loaded: true,
          error: false,
        };
        const resultData = result?.data?.data ? result.data.data : result.data;
        draft.processes = resultData;
        break;
      }
      case ConlicitasegTypes.GET_QUOTES_FAILURE: {
        draft.request.get_quotes = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.SET_FORM_QUOTE: {
        draft.formProcess = { ...draft.formProcess, ...payload };
        break;
      }
      case ConlicitasegTypes.SET_AUTOFILLED_FIELDS: {
        draft.autofilled_fields = Array.from(
          new Set([...(draft.autofilled_fields || []), ...filledFieldNames(payload)]),
        );
        break;
      }
      case ConlicitasegTypes.SET_QUOTE_FLOW: {
        draft.quote_flow = payload.flow;
        draft.guarantee_type = payload.guaranteeType;
        break;
      }
      case ConlicitasegTypes.SET_ORIGIN_CHANNEL: {
        draft.origin_channel = payload;
        break;
      }
      case ProfileTypes.SHOW_SUCCESS: {
        draft.fidelize_login_redirect_pending = true;
        break;
      }
      case ProfileTypes.LOGOUT_SUCCESS: {
        draft.fidelize_login_redirect_pending = false;
        draft.fidelize_email_link_applied = false;
        break;
      }
      case ConlicitasegTypes.CONSUME_FIDELIZE_LOGIN_REDIRECT: {
        draft.fidelize_login_redirect_pending = false;
        break;
      }
      case ConlicitasegTypes.MARK_FIDELIZE_EMAIL_LINK_APPLIED: {
        draft.fidelize_email_link_applied = true;
        break;
      }
      case ConlicitasegTypes.SET_CONTRACT_UPLOADED: {
        draft.contract_uploaded = payload;
        break;
      }
      case ConlicitasegTypes.CLEAR_COMPANY_DATA: {
        draft.company_data_junto = INITIAL_STATE.company_data_junto;
        break;
      }
      case ConlicitasegTypes.CLEAR_RESUME_PROCESS: {
        draft.resume_process = INITIAL_STATE.resume_process;
        break;
      }
      case ConlicitasegTypes.CLEAR_REQUEST_STATE: {
        draft.request = INITIAL_STATE_REQUEST;
        break;
      }
      case ConlicitasegTypes.CLEAR_SEARCH_COMPANY_DATA: {
        draft.request.search_company_data = INITIAL_STATE_REQUEST.search_company_data;
        break;
      }
      case ConlicitasegTypes.CLEAR_COMPANY_NAME: {
        draft.get_company_name = INITIAL_STATE.get_company_name;
        draft.request.get_company_name = INITIAL_STATE_REQUEST.get_company_name;
        break;
      }
      case ConlicitasegTypes.SET_SELECTED_QUOTE_STORE: {
        draft.selected_quote = payload;
        break;
      }
      case ConlicitasegTypes.SET_PAYMENT_INFO: {
        draft.selected_quote = {
          ...draft.selected_quote,
          ...payload,
        };
        break;
      }
      case ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_REQUEST: {
        draft.request.submit_quote_with_payment = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_SUCCESS: {
        draft.request.submit_quote_with_payment = {
          loading: false,
          loaded: true,
          error: false,
        };

        const responseData = result?.data?.data ? result.data.data : result.data;

        draft.selected_quote = {
          ...draft.selected_quote,
          proposal_id: responseData?.response_body?.proposalId,
          status_id: responseData?.response_body?.status_id,
          insurance_process_id: quoteData.insurance_process_id,
        };

        const processIndex = draft.processes.findIndex(
          (process) => process.id === quoteData.insurance_process_id,
        );

        const quoteIndex = draft.processes[processIndex]?.insurance_quotes?.findIndex(
          (quote) => quote.selected_api_quote_id === draft.selected_quote.selected_api_quote_id,
        );

        if (
          quoteIndex !== -1 &&
          processIndex !== -1 &&
          draft.selected_quote.proposal_id &&
          draft.selected_quote.status_id
        ) {
          draft.processes[processIndex].insurance_quotes[quoteIndex].proposal_id =
            draft.selected_quote.proposal_id;
          draft.processes[processIndex].insurance_quotes[quoteIndex].status_id =
            draft.selected_quote.status_id;
        }

        const lastQuoteIndex = draft.last_quotes.findIndex(
          (item) =>
            item.quote_response?.selected_api_quote_id ===
            draft.selected_quote.selected_api_quote_id,
        );

        if (lastQuoteIndex !== -1) {
          const lastQuote = draft.last_quotes[lastQuoteIndex].quote_response;
          if (lastQuote && draft.selected_quote.proposal_id && draft.selected_quote.status_id) {
            lastQuote.proposal_id = draft.selected_quote.proposal_id;
            lastQuote.status_id = draft.selected_quote.status_id;
          }
        }

        break;
      }
      case ConlicitasegTypes.SUBMIT_QUOTE_WITH_PAYMENT_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.submit_quote_with_payment = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.error,
          errorField: errorData?.field,
        };
        break;
      }
      case ConlicitasegTypes.SEARCH_COMPANY_DATA_REQUEST: {
        draft.request.search_company_data = {
          loading: true,
          loaded: false,
          error: false,
        };
        draft.policyholder_register_junto = false;
        break;
      }
      case ConlicitasegTypes.SEARCH_COMPANY_DATA_SUCCESS: {
        draft.request.search_company_data = {
          loading: false,
          loaded: true,
          error: false,
        };

        const result_junto = result.data.junto ? result.data.junto : result.data.junto.data;
        const result_sombrero = result.data.sombrero
          ? result.data.sombrero
          : result.data.sombrero.data;
        const result_pottencial = result.data.pottencial
          ? result.data.pottencial
          : result.data.pottencial.data;
        const result_avla = result.data.avla ? result.data.avla : result.data.avla.data;

        if (result_junto.status !== 'ok') {
          draft.company_data_junto = result_junto;
          draft.policyholder_register_junto = false;
        }

        if (result_junto.status === 'ok') {
          draft.company_data_junto = result_junto;
          draft.policyholder_register_junto = true;
        }

        if (result_pottencial.status !== 'ok') {
          draft.company_data_pottencial = result_pottencial;
          draft.policyholder_register_pottencial = false;
        }

        if (result_pottencial.status === 'ok') {
          draft.company_data_pottencial = result_pottencial;
          draft.policyholder_register_pottencial = true;
        }

        if (result_sombrero?.status !== 'ok') {
          draft.company_data_sombrero = result_sombrero;
          draft.policyholder_register_sombrero = false;
        }

        if (result_sombrero.status === 'ok') {
          draft.company_data_sombrero = result_sombrero;
          draft.policyholder_register_sombrero = true;
        }

        if (result_avla?.status !== 'ok') {
          draft.company_data_avla = result_avla;
          draft.policyholder_register_avla = false;
        }

        if (result_avla.status === 'ok') {
          draft.company_data_avla = result_avla;
          draft.policyholder_register_avla = true;
        }
        break;
      }
      case ConlicitasegTypes.SEARCH_COMPANY_DATA_FAILURE: {
        draft.request.search_company_data = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_PROPOSAL_REQUEST: {
        draft.request.create_proposal = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_PROPOSAL_SUCCESS: {
        draft.request.create_proposal = {
          loading: false,
          loaded: true,
          error: false,
        };

        const responseData = result?.data?.data ? result.data.data : result.data;
        const companyInsurance = draft.selected_quote.insurance_company_id?.toLowerCase();

        if (companyInsurance === 'junto') {
          draft.selected_quote = {
            ...draft.selected_quote,
            proposal_id: responseData?.response_body?.policyNumber,
            status_id: responseData?.response_body?.isIssued ? 'emitida' : 'analise',
          };

          const processIndex = draft.processes.findIndex(
            (process) => process.id === insurance_process_id,
          );

          const quoteIndex = draft.processes[processIndex]?.insurance_quotes?.findIndex(
            (quote) => quote.selected_api_quote_id === responseData?.response_body?.id,
          );

          if (quoteIndex !== -1 && processIndex !== -1) {
            draft.processes[processIndex].insurance_quotes[quoteIndex].proposal_id =
              responseData?.response_body?.policyNumber;
            draft.processes[processIndex].insurance_quotes[quoteIndex].draft_url =
              responseData?.response_body?.documentUrl;
            draft.processes[processIndex].insurance_quotes[quoteIndex].bill_url =
              responseData?.response_body?.billUrl;
            draft.processes[processIndex].insurance_quotes[quoteIndex].status_id = responseData
              ?.response_body?.isIssued
              ? 'emitida'
              : 'analise';
          }

          const lastQuoteIndex = draft.last_quotes.findIndex(
            (item) =>
              item.quote_response?.selected_api_quote_id === responseData?.response_body?.id,
          );

          if (lastQuoteIndex !== -1 && processIndex !== -1) {
            const lastQuote = draft.last_quotes[lastQuoteIndex].quote_response;
            if (lastQuote) {
              lastQuote.proposal_id = responseData?.response_body?.policyNumber;
              lastQuote.draft_url = responseData?.response_body?.documentUrl;
              lastQuote.bill_url = responseData?.response_body?.billUrl;
              lastQuote.status_id = responseData?.response_body?.isIssued ? 'emitida' : 'analise';
            }
          }
        } else if (companyInsurance === 'pottencial') {
          draft.selected_quote = {
            ...draft.selected_quote,
            policy_id: responseData?.response_body?.policyId,
            policy_number: responseData?.response_body?.policyNumber,
            proposal_id: responseData?.response_body?.proposalId,
            status_id: responseData?.response_body?.status === 'Active' ? 'emitida' : 'analise',
          };

          const processIndex = draft.processes.findIndex(
            (process) => process.id === insurance_process_id,
          );

          const quoteIndex = draft.processes[processIndex]?.insurance_quotes?.findIndex(
            (quote) => quote.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (quoteIndex !== -1 && processIndex !== -1) {
            draft.processes[processIndex].insurance_quotes[quoteIndex].policy_id =
              responseData?.response_body?.policyId;
            draft.processes[processIndex].insurance_quotes[quoteIndex].policy_number =
              responseData?.response_body?.policyNumber;
            draft.processes[processIndex].insurance_quotes[quoteIndex].proposal_id =
              responseData?.response_body?.proposalId;
            draft.processes[processIndex].insurance_quotes[quoteIndex].status_id =
              responseData?.response_body?.status === 'Active' ? 'emitida' : 'analise';
          }

          const lastQuoteIndex = draft.last_quotes.findIndex(
            (item) =>
              item.quote_response?.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (lastQuoteIndex !== -1 && processIndex !== -1) {
            const lastQuote = draft.last_quotes[lastQuoteIndex].quote_response;
            if (lastQuote) {
              lastQuote.policy_id = responseData?.response_body?.policyId;
              lastQuote.policy_number = responseData?.response_body?.policyNumber;
              lastQuote.proposal_id = responseData?.response_body?.proposalId;
              lastQuote.status_id =
                responseData?.response_body?.status === 'Active' ? 'emitida' : 'analise';
            }
          }
        } else if (companyInsurance === 'sombrero') {
          draft.selected_quote = {
            ...draft.selected_quote,
            document_number: responseData?.response_body?.PolicyUniqueId,
            policy_number: responseData?.response_body?.ProposalNumber,
            status_id: responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise',
          };

          const processIndex = draft.processes.findIndex(
            (process) => process.id === insurance_process_id,
          );

          const quoteIndex = draft.processes[processIndex]?.insurance_quotes?.findIndex(
            (quote) => quote.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (quoteIndex !== -1 && processIndex !== -1) {
            draft.processes[processIndex].insurance_quotes[quoteIndex].document_number =
              responseData?.response_body?.PolicyUniqueId;
            draft.processes[processIndex].insurance_quotes[quoteIndex].policy_number =
              responseData?.response_body?.ProposalNumber;
            draft.processes[processIndex].insurance_quotes[quoteIndex].status_id =
              responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise';
          }

          const lastQuoteIndex = draft.last_quotes.findIndex(
            (item) =>
              item.quote_response?.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (lastQuoteIndex !== -1 && processIndex !== -1) {
            const lastQuote = draft.last_quotes[lastQuoteIndex].quote_response;
            if (lastQuote) {
              lastQuote.document_number = responseData?.response_body?.PolicyUniqueId;
              lastQuote.policy_number = responseData?.response_body?.ProposalNumber;
              lastQuote.status_id =
                responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise';
            }
          }
        } else if (companyInsurance === 'avla') {
          draft.selected_quote = {
            ...draft.selected_quote,
            document_number: responseData?.response_body?.PolicyUniqueId,
            policy_number: responseData?.response_body?.ProposalNumber,
            status_id: responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise',
          };

          const processIndex = draft.processes.findIndex(
            (process) => process.id === insurance_process_id,
          );

          const quoteIndex = draft.processes[processIndex]?.insurance_quotes?.findIndex(
            (quote) => quote.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (quoteIndex !== -1 && processIndex !== -1) {
            draft.processes[processIndex].insurance_quotes[quoteIndex].document_number =
              responseData?.response_body?.PolicyUniqueId;
            draft.processes[processIndex].insurance_quotes[quoteIndex].policy_number =
              responseData?.response_body?.ProposalNumber;
            draft.processes[processIndex].insurance_quotes[quoteIndex].status_id =
              responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise';
          }

          const lastQuoteIndex = draft.last_quotes.findIndex(
            (item) =>
              item.quote_response?.selected_api_quote_id === responseData?.response_body?.quote_id,
          );

          if (lastQuoteIndex !== -1 && processIndex !== -1) {
            const lastQuote = draft.last_quotes[lastQuoteIndex].quote_response;
            if (lastQuote) {
              lastQuote.document_number = responseData?.response_body?.PolicyUniqueId;
              lastQuote.policy_number = responseData?.response_body?.ProposalNumber;
              lastQuote.status_id =
                responseData?.response_body?.status === 'Emitida' ? 'emitida' : 'analise';
            }
          }
        }

        break;
      }
      case ConlicitasegTypes.CREATE_PROPOSAL_FAILURE: {
        draft.request.create_proposal = {
          loading: false,
          loaded: false,
          error: true,
        };
        const errors = result?.data.data ? result.data.data : result.data;
        draft.request.create_proposal.errorMessage = errors.error;
        break;
      }
      case ConlicitasegTypes.GET_INSURED_REQUEST: {
        draft.request.get_insured = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_INSURED_SUCCESS: {
        draft.request.get_insured = {
          loading: false,
          loaded: true,
          error: false,
        };
        draft.insured_data = result?.data?.data ? result.data.data : result.data;
        break;
      }
      case ConlicitasegTypes.GET_INSURED_FAILURE: {
        draft.request.get_insured = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.GET_QUOTE_BY_ID_REQUEST: {
        draft.request.get_quote_by_id = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_QUOTE_BY_ID_SUCCESS: {
        draft.request.get_quote_by_id = {
          loading: false,
          loaded: true,
          error: false,
        };
        const response = result?.data?.data ? result.data.data : result.data;
        draft.selected_quote = {
          ...draft.selected_quote,
          document_number: response?.document_number,
          document_url: response?.document_url,
          bill_url: response?.bill_url,
          policy_id: response?.policy_number,
        };
        break;
      }
      case ConlicitasegTypes.GET_QUOTE_BY_ID_FAILURE: {
        draft.request.get_quote_by_id = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_JUNTO_REQUEST: {
        draft.request.create_quote_by_company.junto = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_JUNTO_SUCCESS: {
        draft.request.create_quote_by_company.junto = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'junto',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_JUNTO_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.create_quote_by_company.junto = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_REQUEST: {
        draft.request.create_quote_by_company.pottencial = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_SUCCESS: {
        draft.request.create_quote_by_company.pottencial = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'pottencial',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_POTTENCIAL_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.create_quote_by_company.pottencial = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_REQUEST: {
        draft.request.create_quote_by_company.sombrero = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_SUCCESS: {
        draft.request.create_quote_by_company.sombrero = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'sombrero',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_SOMBRERO_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.create_quote_by_company.sombrero = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_AVLA_REQUEST: {
        draft.request.create_quote_by_company.avla = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_AVLA_SUCCESS: {
        draft.request.create_quote_by_company.avla = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'avla',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.CREATE_QUOTE_AVLA_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.create_quote_by_company.avla = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.CREATE_PROCESS_REQUEST: {
        draft.request.create_process = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_PROCESS_SUCCESS: {
        draft.request.create_process = {
          loading: false,
          loaded: true,
          error: false,
        };
        const resultData = result?.data?.data ? result.data.data : result.data;

        draft.processes = [...draft.processes, resultData];
        draft.current_process_id = resultData.id;
        break;
      }
      case ConlicitasegTypes.CREATE_PROCESS_FAILURE: {
        draft.request.create_process = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.SET_RESUME_PROCESS: {
        draft.resume_process = payload;
        break;
      }
      case ConlicitasegTypes.CLEAR_QUOTES_BY_COMPANY: {
        draft.request.create_quote_by_company = INITIAL_STATE_REQUEST.create_quote_by_company;
        draft.last_quotes = [];
        draft.policyholder_register_junto = INITIAL_STATE.policyholder_register_junto;
        draft.request.update_quote_by_company = INITIAL_STATE_REQUEST.update_quote_by_company;
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_JUNTO_REQUEST: {
        draft.request.update_quote_by_company.junto = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_JUNTO_SUCCESS: {
        draft.request.update_quote_by_company.junto = {
          loading: false,
          loaded: true,
          error: false,
        };
        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'junto',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_JUNTO_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.update_quote_by_company.junto = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_REQUEST: {
        draft.request.update_quote_by_company.sombrero = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_SUCCESS: {
        draft.request.update_quote_by_company.sombrero = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'sombrero',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_SOMBRERO_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.update_quote_by_company.sombrero = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_AVLA_REQUEST: {
        draft.request.update_quote_by_company.avla = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_AVLA_SUCCESS: {
        draft.request.update_quote_by_company.avla = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'avla',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_AVLA_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.update_quote_by_company.avla = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_REQUEST: {
        draft.request.update_quote_by_company.pottencial = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_SUCCESS: {
        draft.request.update_quote_by_company.pottencial = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const quoteData = resultData.quote_response;

        const existingProcessIndex = draft.processes.findIndex(
          (process) => process.id === quoteData?.insurance_process_id,
        );

        if (existingProcessIndex !== -1) {
          draft.processes[existingProcessIndex].insurance_quotes = [
            ...(draft.processes[existingProcessIndex].insurance_quotes ?? []),
            quoteData,
          ];
        }

        const existingQuoteIndex = draft.last_quotes.findIndex(
          (item) => item.quote_response?.insurance_company_id?.toLowerCase() === 'pottencial',
        );
        if (existingQuoteIndex !== -1) {
          draft.last_quotes[existingQuoteIndex] = resultData;
        } else {
          draft.last_quotes.push(resultData);
        }
        break;
      }
      case ConlicitasegTypes.UPDATE_QUOTE_POTTENCIAL_FAILURE: {
        const errorData = result?.data?.data ? result.data.data : result?.data;
        draft.request.update_quote_by_company.pottencial = {
          loading: false,
          loaded: false,
          error: true,
          errorMessage: errorData?.quote_response?.message || errorData?.error || 'Erro ao cotar',
        };

        break;
      }
      case ConlicitasegTypes.SET_SECOND_QUOTE_TRY: {
        draft.second_quote_try = payload;
        break;
      }
      case ConlicitasegTypes.CLEAR_SECOND_QUOTE_TRY: {
        draft.second_quote_try = INITIAL_STATE.second_quote_try;
        break;
      }
      case ConlicitasegTypes.CLEAR_CURRENT_PROCESS_ID: {
        draft.current_process_id = INITIAL_STATE.current_process_id;
        break;
      }
      case ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_REQUEST: {
        draft.request.get_bidding_guarantee_data = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_SUCCESS: {
        draft.request.get_bidding_guarantee_data = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        const guaranteeData =
          type_warranty === 'execucao' ? resultData?.execucao : resultData?.participacao;

        const orgaoCnpj = sanitizeCnpj(resultData?.orgao_cnpj || '');

        const valorEstimado = Number(resultData?.valor_estimado_licitacao) || 0;
        const useValorEstimado =
          type_warranty === 'participacao' &&
          valorEstimado > 0 &&
          !(Number(guaranteeData?.contract_value) > 0);

        draft.has_orgao_cnpj = !!orgaoCnpj;
        draft.autofilled_fields = Array.from(
          new Set([
            ...(draft.autofilled_fields || []),
            ...filledFieldNames(guaranteeData || {}),
            ...(orgaoCnpj ? ['insured_cnpj'] : []),
            ...(useValorEstimado ? ['contract_value'] : []),
          ]),
        );
        draft.formProcess = {
          ...draft.formProcess,
          ...guaranteeData,
          ...(orgaoCnpj ? { insured_cnpj: orgaoCnpj } : {}),
          ...(useValorEstimado ? { contract_value: valorEstimado } : {}),
        };
        break;
      }
      case ConlicitasegTypes.GET_BIDDING_GUARANTEE_DATA_FAILURE: {
        draft.request.get_bidding_guarantee_data = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_REQUEST: {
        draft.request.get_fidelize_bidding_guarantee = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_SUCCESS: {
        draft.request.get_fidelize_bidding_guarantee = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result?.data;
        const { form, autofilled } = mergeFidelizeAutofill(resultData, fidelize_fallback || {});

        // Modal do painel preenche sem marcar (mark_autofill = false).
        if (mark_autofill !== false) {
          draft.autofilled_fields = Array.from(
            new Set([...(draft.autofilled_fields || []), ...autofilled]),
          );
        }
        draft.formProcess = { ...draft.formProcess, ...form };
        break;
      }
      case ConlicitasegTypes.GET_FIDELIZE_BIDDING_GUARANTEE_FAILURE: {
        draft.request.get_fidelize_bidding_guarantee = {
          loading: false,
          loaded: false,
          error: true,
        };

        const { form } = mergeFidelizeAutofill(undefined, fidelize_fallback || {});
        draft.formProcess = { ...draft.formProcess, ...form };
        break;
      }
      case ConlicitasegTypes.GET_COMPANY_NAME_REQUEST: {
        draft.request.get_company_name = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_COMPANY_NAME_SUCCESS: {
        draft.request.get_company_name = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        draft.get_company_name = resultData;
        break;
      }
      case ConlicitasegTypes.GET_COMPANY_NAME_FAILURE: {
        draft.request.get_company_name = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_REQUEST: {
        draft.request.get_client_policyholders = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_SUCCESS: {
        draft.request.get_client_policyholders = {
          loading: false,
          loaded: true,
          error: false,
        };

        const resultData = result?.data?.data ? result.data.data : result.data;
        draft.client_policyholders = (Array.isArray(resultData) ? resultData : [])
          .map((policyholderCnpj: string) => sanitizeCnpj(policyholderCnpj || ''))
          .filter(Boolean);
        break;
      }
      case ConlicitasegTypes.GET_CLIENT_POLICYHOLDERS_FAILURE: {
        draft.request.get_client_policyholders = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_REQUEST: {
        draft.request.create_client_policyholder = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      }
      case ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_SUCCESS: {
        draft.request.create_client_policyholder = {
          loading: false,
          loaded: true,
          error: false,
        };

        const created = result?.data?.data ? result.data.data : result.data;
        const createdCnpj = sanitizeCnpj(created?.cnpj || cnpj || '');

        if (!draft.client_policyholders) draft.client_policyholders = [];

        if (createdCnpj && !draft.client_policyholders.includes(createdCnpj)) {
          draft.client_policyholders.unshift(createdCnpj);
        }
        break;
      }
      case ConlicitasegTypes.CREATE_CLIENT_POLICYHOLDER_FAILURE: {
        draft.request.create_client_policyholder = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      }
      default:
        break;
    }
  });
};

export default reducer;
